import React, { Component } from 'react';
import classNames from 'classnames';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import ReactDOM from 'react-dom';
import { Toolbar, Data, Editors, Formatters } from 'react-data-grid-addons';
import _ from 'lodash';
import { UI_HEIGHT } from '../Common/constants';
import { Grid, Row, Col, Panel, Button, DropdownButton, ButtonToolbar, MenuItem, FieldGroup, Input,  Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize, I18n } from 'react-redux-i18n';
import { Field, FieldArray, reset } from 'redux-form';
import Selection from '../Common/selection';
import { InputField, DisabledInputField, ControlledInputField } from '../Common/inputField';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import { SkyLightStateless } from 'react-skylight';
import SalesInventoryInfo from '../../containers/Sales/salesInventoryInfo';
import moment from 'moment';
import ReturnModal from '../../containers/Returns/returnModal';
import warehouseManagementModal from '../Common/modals/warehouseManagement';
import { isOLG, isVAK, isSDR, isCRW, isSC} from '../../actions/root_url';
import SerialNumModal from '../../components/Dispatch/serialNumModal';
import cloneDeep from 'lodash/cloneDeep';
import { fetchLogicalLocation } from '../../actions/receive_actions';

const {
  LocationSelectModal,
} = warehouseManagementModal;

const AutoCompleteEditor = Editors.AutoComplete;


function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

class RestockReturnForm extends Component{
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            invoice: {
              rows: [],
              selectedRows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null,
            },
            totalPrice: 0,
            serialNumOpen: false,
            showInventoryOpen: false,
            currentCustomer_id: null,
            selectedInventoryRow: {},
            curRow: '',
            curTotal: 0,
            curCRV: 0,
            curTax: 0,
            curRestock: 0,
            curRestockP: 0,
            curFinal: 0,
            ReturnFormatter: false,
            IsWeight: false,
            rowChosen: null,
            currentWeights: null,
            backLogWeights: [],
            isLocationSelectModalVisible: false,
            totalLoaded: 0,
            currentRowIdx: null,
            currentSerialNo: '',
            serialArrData: [],
            checkNum: 0,
            locationOptions: [],
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentWillMount() {
      if(!this.props.params.id){
        if (!this.props.currentCustomer) {
          this.context.router.push('/customerReturn/');
        } else {
          this.setState({ currentCustomer_id: this.props.currentCustomer.id });
        }
      }else{
        this.props.fetchSalesReturnDetail(this.props.params.id);
      }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        const { currentSalesInvoice } = this.props;

        if(!currentSalesInvoice && this.props.currentCustomer) {
          this.props.fetchCustomerItem(this.props.currentCustomer.value)
        }
        else if(typeof currentSalesInvoice == "object" && currentSalesInvoice && currentSalesInvoice.SalesReturn_id != null){
          this.props.fetchSalesReturnDetail(currentSalesInvoice.SalesReturn_id);
        }
        else if(typeof currentSalesInvoice == "object" && currentSalesInvoice)
          this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice.SalesInvoice_id);
        else if(currentSalesInvoice)
          this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice, "InvoiceNum");
        // this.props.fetchSalesInvoice("1900-01-01", "3000-01-01", null, 7);
        if (isVAK) {
          this.fetchLogicalLocations(this.props.selectedCompany, this.props.selectedWarehouse);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.salesReturnDetail && this.props.params.id && nextProps.salesReturnDetail != this.props.salesReturnDetail) {
          let selectedRows = [...nextProps.salesReturnDetail.Sales_Return_Line];
          for (let i = 0; i < selectedRows.length; i++){
            selectedRows[i].isSelected = true;
          }
          let invoice = {...this.state.invoice, rows: selectedRows, selectedRows, TaxRate: nextProps.salesReturnDetail.TaxRate };
          this.setState({ invoice, curRestock: nextProps.salesReturnDetail.RestockingFee, curRestockP: nextProps.salesReturnDetail.RestockingFeePercentage });
        }
        if (nextProps.selectedWarehouse && nextProps.selectedWarehouse !== this.props.selectedWarehouse) {
          this.fetchLogicalLocations(this.props.selectedCompany, nextProps.selectedWarehouse);
        }
    }

  fetchLogicalLocations = (company, warehouse) => {
    fetchLogicalLocation(company.value, warehouse.value).then(response => {
      this.setState({
        locationOptions: Array.prototype.concat(
          response.excellent_location.map((location, index) => ({id: index, value: location.zone_num, text: location.description})),
          response.defective_location.map((location, index) => ({id: index, value: location.zone_num, text: location.description})),
        ),
      })
    })
  }
    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton});
    }


    formatDate(date) {
      let formattedDate = date.getFullYear() + '-';

      formattedDate += date.getMonth()+1 + '-';
      if (date.getDate() < 10) {
        formattedDate += '0' + date.getDate();
      } else {
        formattedDate += date.getDate();
      }
      return formattedDate;
    }


    closeReturnModal = () => { this.setState({ ReturnModalOpen: false, IsWeight: false}); }

    openWeightModule = () => { this.setState({ ReturnModalOpen: true, IsWeight: true }); }
    openQuantityModule = () => { this.setState({ ReturnModalOpen: true, IsWeight: false}); }

    setWeights = (currentRow, currentWeights, currentTotalWeight) => {
        // let backLogWeights = [...this.state.backLogWeights];
        // let newEntry = { currentRow, currentWeights };
        // backLogWeights.push(newEntry);
        // this.setState({backLogWeights});
        let invoice = {...this.state.invoice}
        let RestockWeightsList = [];
        for(let k = 0; k < currentWeights.length; k++){
          if(currentWeights[k].isSelected)
            RestockWeightsList.push(currentWeights[k].Weight);
        }
        for(let i = 0; i < this.state.invoice.rows.length; i++){
          if ((currentRow === this.state.invoice.rows[i].SalesOrderLine_id) || (currentRow === this.state.invoice.rows[i].SalesInvoiceLine_id)){
              invoice.rows[i].RestockWeight = parseFloat(currentTotalWeight);
              invoice.rows[i].RestockQuantity = RestockWeightsList.length;
              invoice.rows[i].RestockWeightsList = [...RestockWeightsList];
          }
        }
        this.setState({invoice});
    }

    returnTotalWeight(totalWeight) {
      // console.log("this is the return weight", totalWeight);
    }
    getLocationOptionsVak = () => {
      const {locationOptions} = this.state;
      return I18n._locale === 'ch'
        ? locationOptions
        : locationOptions.map(item => ({
          ...item,
          text: item.value
        }))
    }
    renderInvoice() {
      let that = this;
      if (this.props.isLoading && !this.props.error) return <Spinner/>
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.invoice);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var invoice = {...this.state.invoice, sortColumn: sortColumn, sortDirection: sortDirection};
              this.setState({ invoice });
          }

          const handleRowUpdated = e => {
            let rows = getRows();//this.state.invoice.rows;
            const rowsClone = cloneDeep(rows);
            Object.assign(rows[e.rowIdx], e.updated);
            let returnQuantity = parseFloat(rows[e.rowIdx].ReturnQuantity) || 0;
            if(e.cellKey == "ReturnQuantity" && this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed'){
              let invoice = {...this.state.invoice};
              if (invoice.rows[e.rowIdx].Quantity < e.updated.ReturnQuantity )
                invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].Quantity;
              else
                invoice.rows[e.rowIdx].ReturnQuantity = e.updated.ReturnQuantity;
              if (invoice.rows[e.rowIdx].InvoiceQuantity < e.updated.ReturnQuantity)
                invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].InvoiceQuantity;
              else
                invoice.rows[e.rowIdx].ReturnQuantity = e.updated.ReturnQuantity;
              if(e.updated.ReturnQuantity < 0)
                invoice.rows[e.rowIdx].ReturnQuantity = 0;
              invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(e.updated.ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 4)).toFixed(4);
              if(this.props.params.id)
                invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV / invoice.rows[e.rowIdx].InvoiceQuantity) * e.updated.ReturnQuantity, 4)).toFixed(4);
              else
                invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV / invoice.rows[e.rowIdx].Quantity) * e.updated.ReturnQuantity, 4)).toFixed(4);
              this.setState({ invoice });
            } else if (e.cellKey == "ReturnQuantity" && this.props.params.id){
              let invoice = {...this.state.invoice};
              let currentWeights = {};
              currentWeights.Weights = invoice.rows[e.rowIdx].InvoiceWeightsList;
              that.setState({ rowChosen: invoice.rows[e.rowIdx].SalesOrderLine_id, currentWeights})
              that.openWeightModule(invoice.rows[e.rowIdx]);
            }
            if(e.cellKey == "RestockQuantity"){
              let invoice = {...this.state.invoice};
              let restockQuantity;
              if (invoice.rows[e.rowIdx].ReturnQuantity < e.updated.RestockQuantity )
                restockQuantity = invoice.rows[e.rowIdx].ReturnQuantity;
              else
                restockQuantity = e.updated.RestockQuantity;
              if(parseFloat(e.updated.RestockQuantity) < 0)
                restockQuantity = 0;
              if (isVAK) {
                let rowData = invoice.rows[e.rowIdx];
                if (invoice.rows[e.rowIdx].Attributes2 === 'finished_parts' && !!invoice.rows[e.rowIdx].SalesInvoiceLine_id) {
                  this.setState({
                    totalLoaded: parseFloat(rowData.ReturnQuantity),
                    currentSerialNo: rowData.SerialNum || '',
                    currentRowIdx: e.rowIdx,
                    serialArrData: rowData.serialArrData || [],
                    checkNum: parseFloat(restockQuantity)
                  }, () => {
                    this.setState({
                      serialNumOpen: true,
                    })
                  });
                  invoice.rows[e.rowIdx].RestockQuantity = rowsClone[e.rowIdx].RestockQuantity;
                  // return;
                }
              }
              invoice.rows[e.rowIdx].RestockQuantity = restockQuantity;
              invoice.rows[e.rowIdx].RestockWeight = ((invoice.rows[e.rowIdx].ReturnWeight/invoice.rows[e.rowIdx].ReturnQuantity) * invoice.rows[e.rowIdx].RestockQuantity);
              this.setState({ invoice });
            }
            if(e.cellKey == "ReturnReason"){
              let invoice = {...this.state.invoice};
              invoice.rows[e.rowIdx].ReturnReason = e.updated.ReturnReason;
              this.setState({ invoice });
            }
          }

          var returnReasonOptions = [
            { id: 0, title: 'Damaged' },
            { id: 1, title: 'Defective' },
            { id: 2, title: 'Not Needed' },
            { id: 3, title: 'Repair' },
            { id: 4, title: 'Wrong Item' },
            { id: 5, title: 'Other' },
            { id: 6, title: 'Missing' },
            { id: 7, title: 'Out' },
            { id: 8, title: 'Short' },
          ];

          const ReasonEditor = <AutoCompleteEditor options={returnReasonOptions} />;

          const IsVariableFormatter = React.createClass({
              render() {
                return <span><Button
                  bsStyle="danger"
                  className="textAlignStyle" style={{ height: '23px', width: '39px', padding: '0px' }}
                  onClick={() => {
                    var ProductNum = this.props.dependentValues.ProductNum;
                    that.removeRow(ProductNum);
                  }}>X</Button></span>;
                }
          });

          const onRowsSelected = (rows) => {
              let newRows = this.state.invoice.rows;
              // for (let i = 0; i < newRows.length; i++) {
              //    newRows[i].isSelected = false;
              // }
              let curRow = false;
              rows.map (r => {
                newRows[r.rowIdx].isSelected = true;
                if (!newRows[r.rowIdx].Restock)
                  newRows[r.rowIdx].Restock = 0;
              });
              let selectedRows = [...this.state.invoice.selectedRows];
              selectedRows = selectedRows.concat(rows.map(r => r.row));
              let invoice = {...this.state.invoice, rows: newRows, selectedRows: selectedRows};
              this.setState({
                invoice
              });
          }

          const onRowsDeselected = (rows) => {
              let newRows = this.state.invoice.rows;
              rows.map (r => {
                newRows[r.rowIdx].isSelected = false;
              });
              let selectedRows = [...this.state.invoice.selectedRows];
              selectedRows = selectedRows.filter(function(obj){
                 return obj.isSelected == true;
              })
              let invoice = {...this.state.invoice, rows: newRows, selectedRows: selectedRows};
              this.setState({
                invoice
              });
          }
          // let reasonEditor = <DropDownEditor options={returnReasonOptions} />;
          // let reasonFormattor = <DropDownFormatter options={returnReasonOptions} value='bug' />;

          const IsFixedFormatter = React.createClass({
              render() {
                if (this.props.dependentValues.ProductType === "Non-Fixed") {
                  return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
                } else {
                  return <span>{this.props.value}</span>;
                }
              }
          });

          const ReturnWeightFormatter = React.createClass({
              render() {
                // return (
                //   (this.props.dependentValues.ProductType === 'Non-Fixed') ?
                //     <span>{(this.props.dependentValues.ReturnWeight ||  this.props.dependentValues.ReturnWeight === 0) ? this.props.dependentValues.ReturnWeight : ''}</span> :
                //     <span style={{color: 'gray'}}>N/A</span>
                // );
                return (<span>{(this.props.dependentValues.ReturnWeight ||  this.props.dependentValues.ReturnWeight === 0) ? this.props.dependentValues.ReturnWeight : ''}</span>);
              }
          });

          const RestockWeightFormatter = React.createClass({
              render() {
                return (<span>{(this.props.dependentValues.RestockWeight ||  this.props.dependentValues.RestockWeight === 0) ? this.props.dependentValues.RestockWeight : ''}</span>
                );
              }
          });

          const RestockFormatter = React.createClass({
            render() {
              // if(this.props.dependentValues)
              //   return(this.props.dependentValues.ProductType !== 'Fixed' && !this.props.dependentValues.RestockQuantity) ?
              //     <span><Button
              //     bsStyle="primary"
              //     className="textAlignStyle" style={{ height: '20px', width: '120px', padding: '0px' }}
              //     disabled={!this.props.dependentValues.isSelected}
              //     onClick={() => {
              //       let currentWeights = {};
              //       currentWeights.Weights = this.props.dependentValues.ReturnWeightsList;
              //       that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights})
              //       that.openWeightModule(this.props.dependentValues);
              //       console.log("check dependentValues", this.props.dependentValues);
              //     }}><Translate value="process" /></Button></span> :
              //     <span>{(this.props.dependentValues.RestockQuantity) ? this.props.dependentValues.RestockQuantity : ''}</span>;
              // }
              if(this.props.dependentValues){
                if (!this.props.dependentValues.RestockQuantity && this.props.dependentValues.ProductType === 'Non-Fixed') {
                  return(
                    <span><Button
                    bsStyle="primary"
                    className="textAlignStyle" style={{ height: '20px', width: '120px', padding: '0px' }}
                    disabled={!this.props.dependentValues.isSelected}
                    onClick={() => {
                        let currentWeights = {};
                        currentWeights.Weights = this.props.dependentValues.ReturnWeightsList;
                        that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights})
                        that.openWeightModule(this.props.dependentValues);
                        // console.log("check dependentValues", this.props.dependentValues);
                    }}><Translate value="process" /></Button></span> );
                } else if (this.props.dependentValues.ProductType === 'Fixed' || this.props.dependentValues.ProductType === 'Per-Pound') {
                  return (
                    <span>{(this.props.dependentValues.RestockQuantity || this.props.dependentValues.RestockQuantity === 0) ? this.props.dependentValues.RestockQuantity : ''}</span>
                  );
                } else {
                  return(
                    <span>{(this.props.dependentValues.RestockQuantity)}{' '}<Button
                    bsStyle="warning"
                    className="textAlignStyle" style={{ height: '20px', width: '60px', padding: '0px' }}
                    disabled={!this.props.dependentValues.isSelected}
                    onClick={() => {
                        let currentWeights = {};
                        currentWeights.Weights = this.props.dependentValues.ReturnWeightsList;
                        that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights });
                        that.openWeightModule(this.props.dependentValues);
                        // console.log("check dependentValues", this.props.dependentValues);
                    }}><Translate value="change" /></Button></span> );
                }
              }
            }
          });

          const columns = [
            {
                key: 'ProductNum',
                name: <Translate value="product_num" />,
                resizable: true,
                sortable: true,
                width: 140,
                filterable: true
            },
            {
                key: 'Name',
                name: <Translate value="name" />,
                resizable: true,
                sortable: true,
                width: 140,
                filterable: true,
            },
            {
                key: 'Description',
                name: <Translate value="description" />,
                resizable: true,
                sortable: true,
                width: 160,
                filterable: true,
            },
            {
                key: 'UnitPrice',
                name: <Translate value="unit_price" />,
                resizable: true,
                sortable: true,
                width: 95,
                filterable: true,
            },
            {
                key: 'ReturnQuantity',
                name: <Translate value="return_qty" />,
                resizable: true,
                sortable: true,
                width: 105,
                filterable: true,
                formatter: IsFixedFormatter,
                getRowMetaData: (row) => row,
            },
            {
                key: 'ReturnWeight',
                name: <Translate value="rtn_wt" />,
                resizable: true,
                sortable: true,
                width: 80,
                filterable: true,
                formatter: ReturnWeightFormatter,
                getRowMetaData: (row) => row,
            },
            {
                key: 'RestockQuantity',
                name: <Translate value="restock_qty" />,
                resizable: true,
                sortable: true,
                editable: (row) => ((row.ProductType === 'Fixed' || row.ProductType === 'Per-Pound') && row.isSelected),
                width: 130,
                filterable: true,
                formatter: RestockFormatter,
                getRowMetaData: (row) => row,
            },

            {
              key: 'location',
              name: <Translate value="location" />,
              resizable: true,
              sortable: true,
              editable: (row) => (row.ProductType === 'Fixed' && row.isSelected),
              width: 130,
              filterable: true,
              getRowMetaData: row => row,
              formatter: (props, index) => {
                const {
                  dependentValues,
                } = props;
                let locationText = dependentValues.location;
                if (isVAK) {
                  const locationOptions = this.getLocationOptionsVak();
                  if (locationText && locationOptions.length > 0) {
                    let location = locationOptions.find(data => data.value === locationText);
                    locationText = location ? location.text : locationText;
                  }
                }
                return <div style={{ width: '100%', height: '20px', }} onDoubleClick={(e) => {
                  e.preventDefault();
                  this.setState({
                    editingLine: dependentValues,
                  });
                  this.setLocationSelectModalVisibility(true);
                }}>{locationText}</div>
              }
            },
            ...isVAK ? [] : [{
              key: 'expire_datetime',
              name: <Translate value="expire_datetime" />,
              resizable: true,
              sortable: true,
              editable: (row) => (row.ProductType === 'Fixed' && row.isSelected),
              width: 260,
              filterable: true,
              // formatter: RestockFormatter,
              // getRowMetaData: (row) => row,
            }],
            {
                key: 'RestockWeight',
                name: <Translate value="restock_wt" />,
                resizable: true,
                sortable: true,
                width: 130,
                filterable: true,
                formatter: RestockWeightFormatter,
                getRowMetaData: (row) => row,
            },
          ]

          return (
              <Row>
                <Col sm={ 12 }>
                  <div id="RestockReturnForm-dataGrid1">
                    <ReactDataGrid
                        rowKey='Product_id'
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowHeight={25}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        onRowUpdated={handleRowUpdated}
                        minHeight={this.state.tableHeight}
                        onGridRowsUpdate={()=>{console.log("grid row updating")}}
                        // enableRowSelect='single'
                        enableCellSelect={true}
                        // rowSelection={{
                        //   showCheckbox: true,
                        //   onRowsSelected: onRowsSelected,
                        //   onRowsDeselected: onRowsDeselected,
                        //   selectBy: {
                        //     isSelectedKey: 'isSelected'
                        //   }
                        // }}
                        />
                  </div>
                </Col>
              </Row>
          )
      }
    }

    handleComplete = () => {
      this.props.completeReturn(this.props.params.id, this.state.invoice.rows);
    }

    validateRecords = () => {
      return this.state.invoice.rows.every(line => !!line.RestockQuantity);
    }

    // handleRestock = (e) =>{
    //   if (typeof parseFloat(e.target.value, 10) !== 'NaN' && (e.target.value !== '')) {
    //     let curRestock = e.target.value;
    //     let invoice = {...this.state.invoice};
    //     this.setState({curRestock, invoice});
    //   }else if (e.target.value === ''){
    //     this.setState({curRestock: '' });
    //   }
    // }

    handleRestock = (e) => {
      if (typeof parseFloat(e.target.value, 10) !== 'NaN' && (e.target.value !== '')) {
        const curRestock = e.target.value;
        const invoice = { ...this.state.invoice };
        let curRestockP = 0;
        let total = 0
  
        for (let i = 0; i < invoice.selectedRows.length; i++) {
          total += invoice.selectedRows[i].ReturnTotalPrice ? Number(invoice.selectedRows[i].ReturnTotalPrice) : 0;
        }
        curRestockP = curRestock ? (Number(curRestock)*100)/total : 0;
        curRestockP = curRestockP.toFixed(2);
  
        this.setState({ curRestock, curRestockP, invoice });
      } else if (e.target.value === '') {
        this.setState({ curRestock: '', curRestockP: '' });
      }
    }

    handleRestockP = (e) => {
      if (typeof parseFloat(e.target.value, 10) !== 'NaN' && (e.target.value !== '')) {
        let curRestock = 0;
        const curRestockP = e.target.value;
        const invoice = { ...this.state.invoice };
  
        for (let i = 0; i < invoice.selectedRows.length; i++) {
          curRestock += invoice.selectedRows[i].ReturnTotalPrice ? Number(invoice.selectedRows[i].ReturnTotalPrice)*(Number(curRestockP)/100) : 0;
          // total += (invoice.selectedRows[i].ReturnTotalPrice) ? roundTo(parseFloat(invoice.selectedRows[i].ReturnTotalPrice), 2) : 0;
        }
        curRestock = curRestock.toFixed(2);
  
        this.setState({ curRestockP, curRestock, invoice });
      } else if (e.target.value === '') {
        this.setState({ curRestockP: '', curRestock: '' });
      }
    }

    setLocationSelectModalVisibility = (isLocationSelectModalVisible = false) => this.setState({ isLocationSelectModalVisible });
    handleLocationSelect = (location) => {
      const newLine = {
        ...this.state.editingLine,
        ...location,
      };
      const rows = [...this.state.invoice.rows];
      rows.forEach((row, idx) => {
        if (row.SalesReturnLine_id === newLine.SalesReturnLine_id) {
          rows[idx] = newLine
        }
      })
      this.setState({
        invoice: {
          ...this.state.invoice,
          rows,
        }
      }, () => {
        this.setLocationSelectModalVisibility();
      });
    }
    closeSerialNum = () => {
      this.setState({serialNumOpen: false});
    }
    setSerialNums = (serialNums) => {
      const { rows } = this.state.invoice;
      if (this.state.currentRowIdx !== null) {
        rows[this.state.currentRowIdx].RestockQuantity = serialNums;
        this.setState({
          invoice: {
            ...this.state.invoice,
            rows,
          },
          currentRowIdx: null,
        })
      }
    }
    returnSerialNums = (serialNums) => {
      const { rows } = this.state.invoice;
      if (this.state.currentRowIdx !== null) {
        rows[this.state.currentRowIdx].SerialNum = serialNums;
        this.setState({
          invoice: {
            ...this.state.invoice,
            rows,
          },
          currentRowIdx: null,
        })
      }
    }
    getSerialArr = (serialArrData) => {
      const { rows } = this.state.invoice;
      if (this.state.currentRowIdx !== null) {
        rows[this.state.currentRowIdx].serialArrData = serialArrData
        rows[this.state.currentRowIdx].Idx = serialArrData.filter(item => item.isSelected).map(item => item.Idx).join(',')
        this.setState({
          invoice: {
            ...this.state.invoice,
            rows,
          },
          currentRowIdx: null,
        })
      }
    }
    render() {
        let createDialogInventoryStyle = {
          height: '700px',
          width: '1000px',
          marginLeft: '-28%',
          marginTop: '-20%',
        };
        let createDialogStyleWeight = {
          width: '500px',
          height: '600px',
          top: '45%',
          marginLeft: '-10%',
        };
        let createDialogStyle = {
          width: '500px',
          height: '500px',
          top: '45%',
          marginLeft: '-10%',
        };
        const selectInventoryInformation = (<Translate value="select_inventory_information" />);
        const salesInvoiceDetail = (!this.props.params.id) ? this.props.salesInvoiceDetail : this.props.salesReturnDetail;
        if (this.props.salesReturnDetail && this.props.salesReturnDetail.SRNum)
          salesInvoiceDetail.InvoiceNum = (this.props.params.id) ? this.props.salesReturnDetail.SRNum.slice(0, -1) : salesInvoiceDetail.InvoiceNum;
        const { handleSubmit } = this.props;
        let Customer_Name = '';
        if (salesInvoiceDetail) {
          Customer_Name = (salesInvoiceDetail.Customer_Name) ? salesInvoiceDetail.Customer_Name : salesInvoiceDetail.Deliver_Customer_Name;
        }
        let tax = 0;
        let total = 0;
        let CRV = 0;
        let finalPrice = 0;
        for(let i = 0; i < this.state.invoice.selectedRows.length; i++){
          total += (this.state.invoice.selectedRows[i].ReturnTotalPrice) ? parseFloat(this.state.invoice.selectedRows[i].ReturnTotalPrice) : 0;
          if (this.state.invoice.selectedRows[i].IsTaxable && this.state.invoice.selectedRows[i].ReturnTotalPrice)
            tax += (parseFloat(this.state.invoice.TaxRate) / 100.0) * parseFloat(this.state.invoice.selectedRows[i].ReturnTotalPrice);
          CRV += parseFloat(this.state.invoice.selectedRows[i].CRV);
        }
        tax = parseFloat(roundTo(tax, 2)).toFixed(2);
        total = parseFloat(roundTo(total, 2)).toFixed(2);
        CRV = parseFloat(roundTo(CRV, 2)).toFixed(2);
        finalPrice = parseFloat(roundTo((parseFloat(total) || 0) + (parseFloat(CRV) || 0) + (parseFloat(tax) || 0) - (parseFloat(this.state.curRestock) || 0), 2)).toFixed(2);
        return (
          <ContentWrapper>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Translate value="returns" />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Translate value="sales_return" />
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value="restock_sales_return" />
              </Breadcrumb.Item>
            </Breadcrumb>
          <ButtonToolbar id="breadcrumbButtonGroup">
            <Button
              bsStyle="success"
              disabled={this.state.invoice.selectedRows.length === 0 || this.props.inventoryReturnIsLoading || (isVAK && !this.validateRecords())}
              onClick={()=>{ this.handleComplete(); }} >
                <span><em className="fa fa-save" /><Translate value="save" /></span>
            </Button>
            <Button
              bsStyle="danger"
              type="button"
              onClick={() => { this.context.router.push('/inventoryReturn')}} >
              <em className="fa fa-close"/><Translate value="cancel" />
            </Button>
          </ButtonToolbar>
            <br/>
            <Grid id="sales-customer-return-form" >
              <Row>
                <Col xs={12}>
                  <h1><Translate value="restock_sales_return" /></h1>
                </Col>
              </Row>
              <Row>
                <Col xs={8}>
                  <Panel>
                    <Row>
                      <Col sm ={3}>
                        <Row>
                          <Col xs={12}>
                            <h3><Translate value="customer" /></h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={6}>
                            <label><Translate value="name" />:</label>
                          </Col>
                          <Col xs={6}>
                            {Customer_Name}
                          </Col>
                        </Row>

                      </Col>
                      <Col xs={6}>
                        <Row>
                          <Col xs={12}>
                            <h3><Translate value="invoice" /></h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={2}>
                            <label><Translate value="no" />:</label>
                          </Col>
                          <Col xs={7}>
                            {salesInvoiceDetail && salesInvoiceDetail.InvoiceNum}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={2}>
                            <label><Translate value="sales" />:</label>
                          </Col>
                          <Col xs={7}>
                            {salesInvoiceDetail && salesInvoiceDetail.Sales_User_Name}
                          </Col>
                        </Row>

                      </Col>
                      <Col xs={3}>
                        <Row>
                          <Col xs={12}>
                            <h3><Translate value="return" /></h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={4}>
                            <label><Translate value="no" />:</label>
                          </Col>
                          <Col xs={8}>
                            {salesInvoiceDetail && salesInvoiceDetail.InvoiceNum}{'R'}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={4}>
                            <label><Translate value="date" />:</label>
                          </Col>
                          <Col xs={8}>
                            <Field name="OrderDate" selected={moment().format("MM-DD-YY")} component={DisabledDatePicker} />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={4}>
                            <label><Translate value="user" />:</label>
                          </Col>
                          <Col xs={8}>
                            {salesInvoiceDetail && salesInvoiceDetail.Modifier_User_Name /*right?*/}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Panel>
                </Col>
                <Col xs={4}>
                  <Panel>
                    <Row>
                      <Col xs={12}>
                        <h3><Translate value="return_details" /></h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={2}>
                        <Row>
                          <Col xs={12}>
                            <label style={{'display': 'inline-flex'}}><Translate value="total" /><span className="dollar-sign"> $$</span>:</label>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Field name="ReturnTotal" component={DisabledInputField} placeholder={total}/>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={2}>
                        <Row>
                          <Col xs={12}>
                            <label><Translate value="crv" />:</label>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Field name="CRV" component={DisabledInputField} placeholder={CRV} />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={2}>
                        <Row>
                          <Col xs={12}>
                            <label><Translate value="tax" />:</label>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Field name="Tax" component={DisabledInputField } placeholder={tax}/>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={3}>
                        <Row>
                          <Col xs={12}>
                            <label><Translate value="restock" />($):</label>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Field name="curRestock" component={DisabledInputField} placeholder={this.state.curRestock} />
                          </Col>
                        </Row>
                      </Col>
                      {(isSDR || isCRW || isSC) &&
                        <Col xs={3}>
                        <Row>
                          <Col xs={12}>
                            <label><Translate value="restock" />(%):</label>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Field name="curRestockP" component={DisabledInputField} placeholder={this.state.curRestockP} />
                          </Col>
                        </Row>
                      </Col>
                    }
                      <Col xs={2}>
                        <Row>
                          <Col xs={12}>
                            <label style={{'display': 'inline-flex'}}><Translate value="final" /><span className="dollar-sign"> $$</span>:</label>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Field name="FinalTotal" component={DisabledInputField} placeholder={finalPrice}/>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Panel>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Panel>
                    { this.renderInvoice() }
                  </Panel>
                </Col>
              </Row>
          </Grid>
          <LocationSelectModal
            setModalVisibility={this.setLocationSelectModalVisibility}
            isVisible={this.state.isLocationSelectModalVisible}
            onConfirm={this.handleLocationSelect}
            selectedWarehouse={this.props.selectedWarehouse}
            editingLine={this.state.editingLine}
          />
          <SkyLightStateless dialogStyles={createDialogStyleWeight} isVisible={this.state.ReturnModalOpen} onCloseClicked={() => { this.closeReturnModal(); }} title="Return Products">
              <ReturnModal invoice setWeights={this.setWeights} keepLoaded={()=>{}} currentWeights={this.state.currentWeights} closeC={this.closeReturnModal} totalLoaded={2} rowChosen={this.state.rowChosen} returnTotalWeight={this.returnTotalWeight.bind(this)} />
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={createDialogInventoryStyle} isVisible={this.state.showInventoryOpen} onCloseClicked={ ()=> {
              this.closeShowInventory('productSearch')}} title={selectInventoryInformation}>
              <SalesInventoryInfo
                Customer_id={this.state.currentCustomer_id}
                SearchType={this.props.searchType}
                SearchValue={this.props.searchValue}
                closeShowInventory={this.closeShowInventory}
                selectInventoryInfo={this.selectInventoryInfo}
                setSaleRowValue={this.props.setSaleRowValue}
                setAllProductQuantity={this.setAllProductQuantity}
                formName="restockReturnForm"
              />
          </SkyLightStateless>
            <SkyLightStateless
              dialogStyles={createDialogStyle}
              isVisible={this.state.serialNumOpen}
              onCloseClicked={() => { this.closeSerialNum() }}
              title={<Translate value="select_serial_num" />}>
              <SerialNumModal
                closeC={this.closeSerialNum}
                totalLoaded={ this.state.totalLoaded }
                returnSerialNums={ this.returnSerialNums }
                getSerialArr={this.getSerialArr}
                keepLoaded={() => {}}
                oldLoaded={0}
                currentSerialNo={this.state.currentSerialNo}
                serialArrData = {this.state.serialArrData}
                setSerialNums={this.setSerialNums}
                isCheckAble
                checkNum = {this.state.checkNum}
              />
            </SkyLightStateless>
          </ContentWrapper>
        )
    }
}

let renderTypeRadios = props => {
    return (
      <div className="form-group" id="search-product-by">
          <label className="col-xs-3 search-by-max-width">
            <Translate value="search_by" />
          </label>
          <label className="col-xs-2" >
              <input {...props.input} type="radio" value="ProductNum"
                checked={props.input.value === "ProductNum"}/>
              <Translate value="prod_num" />
          </label>
          <label className="col-xs-2">
            <input {...props.input} type="radio" value="RefNum"
              checked={props.input.value === "RefNum"}/>
            <Translate value={isOLG ? "item_no" : "ref_num"} />
          </label>
          <label className="col-xs-2" >
              <input {...props.input} type="radio" value="Name"
                checked={props.input.value === "Name"}/>
              <Translate value="name" />
          </label>
          <label className="col-xs-2" >
              <input {...props.input} type="radio" value="Description"
                checked={props.input.value === "Description"}/>
              <Translate value="description" />
          </label>
      </div>
    )
}

export default RestockReturnForm;

function roundTo(n, digits) {
 if (digits === undefined) {
   digits = 0;
 }

 var multiplicator = Math.pow(10, digits);
 n = parseFloat((n * multiplicator).toFixed(11));
 var test =(Math.round(n) / multiplicator);
 return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/restockReturnForm.jsx